import { useState } from "react";

import { useAuth } from "@/auth/AuthProvider";
import { AppLayout } from "@/components/AppLayout";

import { HomePage } from "./HomePage";
import { LandingPage } from "./LandingPage";

export function HomeRoute() {
  const { user, isLoading } = useAuth();
  const [editing, setEditing] = useState(false);

  if (isLoading) return null;

  if (!user) return <LandingPage />;

  return (
    <AppLayout>
      <HomePage editing={editing} onEditingChange={setEditing} />
    </AppLayout>
  );
}
